export default function HrLeaves() {
    return (
      <div className="p-6 bg-white rounded-xl shadow space-y-6">
        <h1 className="text-3xl font-bold text-gray-700">Leaves</h1>
        <p className="text-gray-500">View and approve employee leave requests.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 border">Employee</th>
                <th className="p-3 border">Leave Type</th>
                <th className="p-3 border">From</th>
                <th className="p-3 border">To</th>
                <th className="p-3 border">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border">John Doe</td>
                <td className="p-3 border">Sick Leave</td>
                <td className="p-3 border">2025-12-01</td>
                <td className="p-3 border">2025-12-03</td>
                <td className="p-3 border text-green-500 font-semibold">Approved</td>
              </tr>
              <tr>
                <td className="p-3 border">Jane Smith</td>
                <td className="p-3 border">Casual Leave</td>
                <td className="p-3 border">2025-12-10</td>
                <td className="p-3 border">2025-12-12</td>
                <td className="p-3 border text-yellow-500 font-semibold">Pending</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  